function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { ServiceProviderIdentifierType } from "@amzn/coral_com-amazon-carrierlogisticswebserver-model";
export var MONS_DIRECTOR_ID_QUERY_PARAM = "mons_sel_dir_paid";
export var MONS_RETURN_TO_URL_KEY = "returnTo";
export var REQUEST_PERMISSIONS_PAGE = "/request/permissions";
var _obj;
export var SERVICE_PROVIDER_MAPPING = (_obj = {
    all: "service_provider_options.all"
}, _define_property(_obj, ServiceProviderIdentifierType.LOGISTICS_PARTY_ID, "service_provider_options.lp"), _define_property(_obj, ServiceProviderIdentifierType.DSP_COMPANY_ID, "service_provider_options.dsp"), _obj);
export var SERVICE_PROVIDER_OPTIONS = Object.keys(SERVICE_PROVIDER_MAPPING);
export var SERVICE_PROVIDER_TAGS = _define_property({}, ServiceProviderIdentifierType.DSP_COMPANY_ID, {
    theme: "warning",
    id: "DSP",
    tooltip: "service_provider_options.dsp"
});

//# sourceMappingURL=AppConfig.js.map